import type { DiscountApprovalType } from "../../redux-store/slices/DiscountSlice";

/**
 * Moved from apps/web `helper/hideCloseOptionForDiscountApproval` for the feature gate
 * (`helpers/featureRestrictionHelper`: Close and Quick Settle hide while a discount approval is
 * pending). Mobile's gate has a private function of the same name that takes the whole approval
 * ARRAY; this one takes the latest entry, as web's gate passes it.
 */
export const hideCloseOptionForDiscountApproval = (currentDiscountApprovalData = {} as DiscountApprovalType) => {
    if(Object.keys(currentDiscountApprovalData).length && (currentDiscountApprovalData.isApprovalRequired || currentDiscountApprovalData.isRequested))
    {
       return false
   }
   return true
}
